import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import statusService, { ISetStatus } from "api/statusService";
import { useContext, useMemo, useState } from "react";
import { IStatus } from "dto/IStatus";
import StatusIcon from "assets/icons/flag.svg?react";
import PackagesContext from "contexts/PackagesContext";
import { ItemKind } from "dto/IKindItems";
import CasesContext from "contexts/CasesContext";
import CaseChatContext from "contexts/CaseChatContext";
import { ENotificationType, notification } from "utils/notification";
import CloseIcon from "assets/icons/close.svg?react";
import { useTranslation } from "react-i18next";

const StatusModalLarge: FC<Props> = ({
  toggle,
  item,
  items,
  selectedStatus,
  afterUpdate,
}) => {
  const { t } = useTranslation();
  const { data: statusesData } = statusService.useGetStatuses();
  const { mutate: setStatus } = statusService.useSetStatus();
  const { mutate: setManyStatus } = statusService.useSetManyStatus();

  const [selectedFlag, setSelectedFlag] = useState<IStatus | null>(
    selectedStatus
  );

  const statuses: IStatus[] = useMemo(
    () => statusesData?.data ?? [],
    [statusesData]
  );

  const { packages, setPackages } = useContext(PackagesContext);
  const { cases, setCases } = useContext(CasesContext);
  const { casePackages, setCasePackages } = useContext(CaseChatContext);

  const handleChangeFlag = (flag: IStatus) => {
    setSelectedFlag(flag);
    const newPacks = [...packages];
    const newCases = [...cases];
    const newCasePacks = [...casePackages];

    if (items) {
      setPackages(
        newPacks.map((a) => {
          if (items.find((p) => p.Id === a.Id)) {
            a.StatusId = flag.Id;
            return a;
          }
          return a;
        })
      );

      const itemsToUpdate: ISetStatus[] = items.map((p) => ({
        OwnerId: p.Id,
        OwnerKind: p.Kind,
        StatusId: flag.Id as number,
      }));

      setManyStatus(
        {
          Items: itemsToUpdate,
          StatusId: flag.Id as number,
        },
        {
          onSuccess: () => {
            toggle(false);
            if (afterUpdate) {
              afterUpdate(flag);
            }
          },
          onError: () => {
            notification({
              type: ENotificationType.ERROR,
              title: t("errors.occurred"),
              text: t("errors.somethingWentWrong"),
            });
          },
        }
      );
    } else if (item) {
      const packItem = newPacks.find(
        (p) => p.Id === item.Id && p.Kind === item.Kind
      );
      const caseItem = newCases.find(
        (c) => c.Id === item.Id && c.Kind === ItemKind.Cases
      );
      const packCaseItem = newCasePacks.find(
        (p) => p.Id === item.Id && p.Kind === item.Kind
      );

      if (packItem) {
        packItem.StatusId = flag.Id;
        setPackages(newPacks);
      }

      if (caseItem) {
        caseItem.StatusId = flag.Id;
        setCases(newCases);
      }

      if (packCaseItem) {
        packCaseItem.StatusId = flag.Id;
        setCasePackages(newCasePacks);
      }

      setStatus(
        {
          OwnerId: item.Id,
          OwnerKind: item.Kind,
          StatusId: flag.Id as number,
        },
        {
          onSuccess: () => {
            toggle(false);
            if (afterUpdate) {
              afterUpdate(flag);
            }
          },
          onError: () => {
            notification({
              type: ENotificationType.ERROR,
              title: t("errors.occurred"),
              text: t("errors.somethingWentWrong"),
            });
          },
        }
      );
    }
  };

  const clearFlag = () => {};

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {t("common.status")}
        <CloseIcon
          onClick={(e) => {
            toggle(false);
            e.stopPropagation();
          }}
          className={styles.close}
        />
      </div>
      <div className={styles.content}>
        <div className={styles.flagsWrapper}>
          <div
            onClick={(e) => {
              clearFlag();
              e.stopPropagation();
            }}
            className={`${styles.flag} ${!selectedFlag ? styles.active : ""}`}
          >
            <CloseIcon />
            {t("common.noStatus")}
          </div>
          {statuses
            .filter((status) => status.Type === 1 || status.Type === 3)
            .map((status: IStatus) => (
              <div
                key={status.Id}
                onClick={(e) => {
                  handleChangeFlag(status);
                  e.stopPropagation();
                }}
                className={`${styles.flag} ${
                  selectedFlag?.Id === status.Id ? styles.active : ""
                }`}
              >
                <StatusIcon></StatusIcon>
                {status.Name}
              </div>
            ))}
        </div>
      </div>
      {/* {selectedFlag && (
          <div className={styles.editor}>
            {editMode && item ? (
              <EditMode
                toggle={setEditMode}
                handleCreateStatus={handleCreateStatus}
                handleUpdateStatus={handleUpdateStatus}
                status={!createNew ? selectedFlag : null}
                item={item}
              />
            ) : (
              <PreviewMode
                onClick={() => {
                  setCreateNew(false);
                  setEditMode(true);
                }}
                status={selectedFlag}
              />
            )}
          </div>
        )} */}
      {/* {editMode ? (
        <EditMode
          toggle={setEditMode}
          handleCreateStatus={handleCreateStatus}
          handleUpdateStatus={handleUpdateStatus}
          status={!createNew ? selectedFlag : null}
          item={item ?? undefined}
        />
      ) : (
        <div className={styles.buttonWrapper}>
          <Button
            className={styles.button}
            onClick={() => {
              setCreateNew(true);
              setEditMode(true);
            }}
            text="Dodaj status"
          />
        </div>
      )} */}
    </div>
  );
};

export default StatusModalLarge;
